module.exports = __webpack_public_path__ + "static/img/watermark-removal-platform.85b89eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/watermark-removal-platform.png
// module id = xHLx
// module chunks = 1